import { format } from 'date-fns';

export const customBrowserTimeFormat = (utcDateTimeString) => {
    try {
        const formatOfDate = "hh:mmaaa M/dd";
        const dateParsed = getBrowserLocalDateTime(utcDateTimeString);
        const formatedDate = format(dateParsed, formatOfDate);
        return formatedDate;
    } catch (error) {
        console.error(error);
        return "";
    }
};

export const formatBrowserDate = (utcDateTimeString) => {
    try {
        const formatOfDate = "M/dd/yyyy";
        const dateParsed = getBrowserLocalDateTime(utcDateTimeString);
        const formatedDate = format(dateParsed, formatOfDate);
        return formatedDate;
    } catch (error) {
        console.error(error);
        return "";
    }
};

export const customBrowserFormat = (utcDateTimeString) => {
    try {
        const formatOfDate = "EEEE, MMM d ";
        const dateParsed = getBrowserLocalDateTime(utcDateTimeString);
        const formatedDate = format(dateParsed, formatOfDate);
        return formatedDate;
    } catch (error) {
        console.error(error);
        return "";
    }
};


export const formatBrowserTimeZone = (utcDateTimeString) => {
    try {
        const timeFormat = "h:mm a";

        const dateParsed = getBrowserLocalDateTime(utcDateTimeString);
        const formattedTime = format(dateParsed, timeFormat);
        return formattedTime;
    } catch (error) {
        console.error(error);
        return "";
    }
};


export const formatDateTimeForBrowserTimeZone = (utcDateTimeString) => {
    try {
        const formatOfDate = "M/dd/yyyy @ h:mm a";
        const dateParsed = getBrowserLocalDateTime(utcDateTimeString);
        const formatedDate = format(dateParsed, formatOfDate);
        return formatedDate;
    } catch {
        return "";
    }
};


export const formatDateTimeForBrowserTimeZoneSyncDate = (utcDateTimeString) => {
    try {
        //const formatOfDate = "M/dd/yyyy h:mm a";
        const dateParsed = getBrowserLocalDateTime(utcDateTimeString);
        return new Date(dateParsed).toISOString();
    } catch {
        return "";
    }
};


function getBrowserLocalDateTime(utcDateTimeString) {
    const utcDateTime = new Date(utcDateTimeString);
    const offset = utcDateTime.getTimezoneOffset();

    const localDateTime = new Date(utcDateTime);    
    localDateTime.setMinutes(localDateTime.getMinutes() - offset);

     //const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    //const localDateTime = new Date(utcDateTime.toLocaleString('en-US', { timeZone: targetTimeZone }));
    return localDateTime;
}


export const getLocalTimeZone = () => {
    try {
        const dateObject = new Date();
        const timeStringWithTimeZone = dateObject.toLocaleTimeString('en-US', { timeZoneName: 'long' });
        return timeStringWithTimeZone.slice(11).trim();
    } catch {
        return "";
    }
};
export const customBrowserFormatMDYT = (date) => {
    try {      
        const formatOfDate = "MMM d, yyyy '@' h:mma"; // format string for "Mar 10, 2024 @ 12:07pm"
        const formattedDate = format(date, formatOfDate);
        return formattedDate;
    } catch (error) {
        console.error(error);
        return "";
    }
};